import React from 'react';
import { AlertCircle, Receipt, Wallet } from 'lucide-react';



const AmountMismatchAlert = ({
  finalAmountError,
  totalCostWithDiscount = 0,
  paymodeSum = 0,
}) => {
  // If there is no error, render nothing
  if (!finalAmountError) return null;

  return (
    <div className="mt-6 overflow-hidden rounded-xl border border-red-200 bg-red-50 shadow-sm transition-all animate-in fade-in slide-in-from-top-2">
      
      {/* Error Alert Header */}
      <div className="flex items-center gap-2 border-b border-red-100 bg-red-100/50 px-4 py-3">
        <AlertCircle className="h-5 w-5 shrink-0 text-red-600" strokeWidth={2.5} />
        <p className="text-sm font-semibold text-red-800">
          {finalAmountError}
        </p>
      </div>

      {/* Cost Breakdown Details */}
      <div className="flex flex-col gap-3 p-4">
        {/* Row 1: Software & API Cost */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2 text-red-700/80">
            <Receipt className="h-4 w-4 shrink-0" />
            <span className="font-medium">Software & API Cost (incl. discount)</span>
          </div>
          <span className="font-bold text-nowrap text-red-900">
            Rs. {totalCostWithDiscount}
          </span>
        </div>

        {/* Row 2: Paymode Sum */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2 text-red-700/80">
            <Wallet className="h-4 w-4 shrink-0" />
            <span className="font-medium">Total Installment Sum</span>
          </div>
          <span className="font-bold text-nowrap text-red-900">
            Rs. {paymodeSum}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AmountMismatchAlert;